import React from "react";
import { ChevronLeft } from "react-feather";
import { Link } from "react-router-dom";

export const BackButton = (props) => {

  let bgBtnColor = props.bgBtnColor

  if(!props.bgBtnColor){
    bgBtnColor = "#1199B3";
  }
  return (
    <Link
      to={props.route}
      style={{
        padding: "15px",
        borderRadius: "50%",
        backgroundColor:bgBtnColor,
      }}
    >
      <ChevronLeft size={24} color={"#fff"} />
    </Link>
  );
};
